import React from "react";
import FontAwesome from "react-fontawesome";
import { COLOUR_BRANDING_OFF } from "../../../js";

/**
 * Spinner block shown while fetching or saving info pages.
 * @param {{ message: string }} props
 */
export function LoadingState({ message }) {
	return (
		<div
			className="infopage__loading infopage__container"
			style={{ textAlign: "center" }}
		>
			<FontAwesome
				style={{ fontSize: 30, color: COLOUR_BRANDING_OFF }}
				name="spinner fa-pulse fa-fw"
			/>
			<p>{message}</p>
		</div>
	);
}
